import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmArrowCornerRightUp } from '@websolutespa/bom-mixer-icons';
import { useLlm } from '../../../useLlm/useLlm.js';
import { useLlmView } from '../../../useLlm/useLlmView.js';

const Header = props => {
  var _a, _b, _c, _d;
  const app = useLlm(state => state.app);
  const {
    open
  } = useLlmView(state => state.actions);
  const hidden = useLlmView(state => state.hidden);
  const fixed = useLlmView(state => state.fixed);
  const dismissable = useLlmView(state => state.dismissable);
  const label = useLabel();
  const logo = app === null || app === void 0 ? void 0 : app.contents.logo;
  const logoMini = (_a = app === null || app === void 0 ? void 0 : app.contents) === null || _a === void 0 ? void 0 : _a.logoMini;
  const openingSound = (_b = app === null || app === void 0 ? void 0 : app.contents) === null || _b === void 0 ? void 0 : _b.openingSound;
  const additionalLogos = (_c = app === null || app === void 0 ? void 0 : app.contents) === null || _c === void 0 ? void 0 : _c.additionalLogos;
  const headerCtas = (_d = app === null || app === void 0 ? void 0 : app.contents) === null || _d === void 0 ? void 0 : _d.headerCtas;
  const hasHeaderCtas = headerCtas && headerCtas.length > 0;
  const classes = getClassNames('llm__header', {
    hidden,
    fixed,
    '-has-cta': hasHeaderCtas
  });
  return jsx("nav", {
    className: classes,
    children: jsxs("div", {
      className: "llm__header-wrapper",
      children: [jsxs("div", {
        className: "llm__header-logo",
        children: [logo && jsx("div", {
          className: "llm__header-logo-full",
          children: jsx("img", {
            src: logo.src || logo.url,
            alt: logo.alt
          })
        }), additionalLogos && additionalLogos.map((x, i) => jsx("div", {
          className: "llm__header-logo-additional",
          children: jsx("img", {
            src: x.logo.src || x.logo.url,
            alt: x.logo.alt
          })
        }, i)), logoMini && jsx("div", {
          className: "llm__header-logo-mini",
          children: jsx("img", {
            src: logoMini.src || logoMini.url,
            alt: logoMini.alt
          })
        })]
      }), jsx("a", {
        href: "#llm-prompt-textarea",
        className: "llm__header-skip",
        children: label('llm.skip')
      }), dismissable && jsxs(Fragment, {
        children: [hasHeaderCtas && jsx("div", {
          className: "llm__header-ctas",
          children: headerCtas.map((x, i) => jsxs("a", {
            href: x.href,
            target: x.target || '_blank',
            className: getClassNames('llm__header-cta', {
              '-icon': x.icon != null
            }),
            children: [x.title, " ", x.icon && jsx("i", {
              children: jsx("img", {
                src: x.icon.src || x.icon.url,
                alt: ""
              })
            })]
          }, i))
        }), jsxs("button", {
          type: "button",
          "aria-label": label('llm.back'),
          className: "llm__header-back -llm-t-cta3",
          onClick: () => open(),
          children: [jsx("span", {
            className: "llm__header-back-label",
            children: label('llm.back')
          }), jsx(IconLlmArrowCornerRightUp, {})]
        }), openingSound && jsx("audio", {
          src: openingSound.src || openingSound.url,
          autoPlay: true,
          loop: false
        })]
      })]
    })
  });
};

export { Header };
//# sourceMappingURL=header.js.map
